var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"py-1"},[_c('div',{staticClass:"w-full border-gray-200 dark:border-gray-800 border-b absolute left-0 right-0"})])
}]

export { render, staticRenderFns }